<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>new_releases</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Manejo de Prospectos</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)">
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="listEmpresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="Casos de la Empresa"
              placeholder="Seleccione una"
              :menu-props="{ minWidth: '400' }"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="5">
            <v-radio-group v-model="filtrarPor" :mandatory="false">
              <v-radio value="documento">
                <div slot="label">Buscar por Documento</div>
              </v-radio>
              <v-radio value="nombre">
                <div slot="label">Buscar por Nombre</div>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-if="filtrarPor"
              v-model="filtro.filtro"
              label="Filtro"></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-btn color="success" @click="getItems(true)">Traer Casos</v-btn>
          </v-col>
        </v-row>
        {{ "ITEM:" }}
        {{ item }}
        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light"
                >Lista de Prospectos</v-toolbar-title
              >
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table
              dense
              :headers="headers"
              :items="records"
              :server-items-length="totalItems"
              :rows-per-page="pagination.rowsPerPage"
              :options.sync="pagination"
              v-model="selectedRow"
              :loading="loading"
              :footer-props="footer"
              item-key="id">
              <template v-slot:item="{ item }">
                <!-- <tr @click="viewItem(item)" v-bind:class="[(selectedRow[0] && (selectedRow[0].id == item.id)) ? 'grey lighten-2': 'white']"> -->
                <tr>
                  <td class="text-xs-left caption">{{ item.nombre }}</td>
                  <td class="text-xs-left caption">{{ item.documento }}</td>
                  <td class="text-xs-left caption">{{ item.telefono }}</td>
                  <td class="text-xs-left caption">
                    {{ item.destinoCreditoDescripcion }}
                  </td>
                  <!-- <td class="text-xs-left caption">{{ item.montoSolicitado | currency }}</td> -->
                  <!-- <td class="text-xs-left caption">{{ item.respuestaConsultaDescripcion}}</td> -->
                  <td class="text-xs-left caption">
                    {{ item.canalVentaNombre }}
                  </td>
                  <td class="text-xs-left caption">
                    {{ item.responsableLogin }}
                  </td>
                  <!-- <td class="text-xs-left caption">{{ item.aprobado ? 'SI' : 'NO' }}</td> -->
                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                  <td>
                    <v-icon small @click="viewItem(item)"
                      >remove_red_eye</v-icon
                    >
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                      v-show="canUpdate"
                      >edit</v-icon
                    >
                    <!-- <v-icon small  @click="deleteItem(item)" v-show="canDelete">delete</v-icon> -->
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="nuevoProspecto" v-show="canCreate"
          >Nuevo Prospecto</v-btn
        >
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>

      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  /* components: {
    'alta-modificacion-prospecto': AltaModificacionProspecto
  }, */
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      suspend: false,
      filtrarPor: "",
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [""],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: "Nombre", value: "nombre" },
        { text: "Documento", value: "documento" },
        { text: "Teléfono", value: "telefono", sortable: false },
        { text: "Motivo", value: "motivoProspecto", sortable: false },
        // { text: 'Monto Solicitado', value: 'montoSolicitado',sortable : false},
        // { text: 'Respuesta', value: 'respuestaConsultaDescripcion',sortable : false},
        { text: "Canal de Venta", value: "canalVenta" },
        { text: "Responsable", value: "responsable", sortable: false },
        // { text: 'Aprobado', value: 'aprobado'},
        { text: "Empresa", value: "empresa", sortable: false },
        { text: "Acciones", value: "accion", width: 80, sortable: false },
      ],
      records: [], // registros
      selectedRow: [],
      filtro: { empresaId: 0, filtro: "" },
      listEmpresas: [],
    };
  },
  async created() {
    this.loadEmpresas();
  },
  watch: {
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    activeTask: function () {
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if (this.closeRelatedTasks) {
        this.getItems(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      "checkCanCreate",
      "checkCanUpdate",
      "checkCanDelete",
      "getActionFromLink",
      "user",
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
    canCreate: function () {
      return this.checkCanCreate(this.$route.path);
    },
    canUpdate: function () {
      return this.checkCanUpdate(this.$route.path);
    },
    canDelete: function () {
      return this.checkCanDelete(this.$route.path);
    },
    // action: function () {
    //   return this.getActionFromLink(this.$route.path);
    // },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let documento = this.filtrarPor == "documento" ? this.filtro.filtro : "";
      let nombre = this.filtrarPor == "nombre" ? this.filtro.filtro : "";

      try {
        var result = await http.get(
          "prospectos?empresaId=" +
            this.filtro.empresaId +
            "&documento=" +
            documento +
            "&nombre=" +
            nombre +
            "&limit=" +
            this.pagination.itemsPerPage +
            "&page=" +
            this.pagination.page +
            "&sortby=" +
            this.pagination.sortBy +
            "&descending=" +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : "false"),
        );

        this.records = result.list;
        Vue.$log.debug(this.records);

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          "empresas/list/porusuario?usuarioId=" + this.user.id,
        );

        this.listEmpresas = result.list;
        this.listEmpresas.unshift({ id: 0, nombre: "(Todas)" });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async nuevoProspecto() {
      try {
        var dob = this.$moment(this.model.personaDto.fechaNacimiento);
      } catch {}
      try {
        var edad = "";
        if (dob.isValid) {
          var ageDifMs = Date.now() - dob.toDate().getTime();
          var ageDate = new Date(ageDifMs); // miliseconds from epoch
          edad = Math.abs(ageDate.getUTCFullYear() - 1970);
        }
      } catch {}

      var nuevoProspecto = {
        nombre: "",
        documento: "",
        fechaNacimiento: "",
        ingresos: 0,
        sexoId: 0,
        montoSolicitado: 0,
        cuotaMaxima: 0,
      };

      var params = {
        width: 500,
        prospectoId: "00000000-0000-0000-0000-000000000000",
        editModeProp: true,
        editProspecto: nuevoProspecto,
      };

      this.setActiveTask({
        task: "alta-modificacion-prospecto",
        props: params,
      });
    },
    async editItem(item) {
      this.selectedRow[0] = item;

      var editProspecto = {
        nombre: item.nombre,
        documento: item.documento,
        fechaNacimiento: item.fechaNacimiento,
        ingresos: item.ingresos,
        sexoId: item.sexoId,
        montoSolicitado: item.montoSolicitado,
        cuotaMaxima: item.cuotaMaxima,
      };

      // alert(item.id);
      var params = {
        width: 500,
        prospectoId: item.id,
        editModeProp: true,
        editProspecto: editProspecto,
      };

      Vue.$log.debug("editItem");

      this.setActiveTask({
        task: "alta-modificacion-prospecto",
        props: params,
      });
    },
    async viewItem(item) {
      this.selectedRow[0] = item;
      var params = { width: 500, prospectoId: item.id, editModeProp: false };

      Vue.$log.debug("viewItem");

      this.setActiveTask({
        task: "alta-modificacion-prospecto",
        props: params,
      });
    },
  },
};
</script>
